<template>
  <rexEChartsVue ref="chart" :option="option" />
</template>

<script>
import 'echarts/lib/component/visualMap';
import rexEChartsVue from '../../rex-components/rex-eCharts.vue';

export default {
  name: 'ChartHeatmap',
  components: { rexEChartsVue },
  props: {
    title: {
      type: String
    },
    type: {
      type: String
    },
    data: {},
    item: {},
    intervalTime: {}
  },
  methods: {
    generatePieces(maxValue, colorBox, minItem) {
      const pieces = [];
      let quotient = 1;
      let temp = {};
      temp.max = minItem;
      temp.min = minItem;
      temp.color = colorBox[0];
      pieces.push(temp);
      if (maxValue && maxValue >= 19) {
        quotient = Math.floor(maxValue / 19);
        for (let i = 1; i < 20; i++) {
          temp = {};
          if (i === 1) {
            temp.min = minItem;
          } else {
            temp.min = quotient * (i - 1);
          }
          temp.max = quotient * i;
          temp.color = colorBox[i];
          pieces.push(temp);
        }
      }
      const length = pieces.length;
      if (length) {
        const item = pieces[length - 1];
        item.max = maxValue;
      }
      return pieces;
    },
    resize() {
      const chart = this.$refs.chart;
      chart.myChart.resize();
    }
  },
  computed: {
    option() {
      const source = (this.data.nodes || []).map(d => d[2]);
      const maxItem = Math.max(...source);
      const minItem = Math.min(...source);
      const colorBox = [
        '#fff',
        '#FDF0F0',
        '#FAE2E2',
        '#F8D3D3',
        '#F6C4C4',
        '#F4B5B5',
        '#F1A7A7',
        '#EF9898',
        '#E86C6C',
        '#E44E4E',
        '#E23F3F',
        '#DF3131',
        '#DD2222',
        '#CE2020',
        '#C01D1D',
        '#B11B1B',
        '#A21919',
        '#851414',
        '#761212',
        '#671010'
      ];
      return {
        tooltip: {
          position: 'top',
          formatter: a =>
            `${a.data[1] * 100}${this.item.unit}  [ ${a.data[2]} ]`,
          textStyle: {
            fontSize: 13
          }
        },
        grid: {
          top: 15,
          left: 0,
          right: 10,
          bottom: 5,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.intervalTime,
          axisTick: {
            lineStyle: { color: '#c1c5ca' },
            alignWithLabel: true
          },
          splitLine: { show: false },
          axisLine: { lineStyle: { color: 'rgba(0,0,0,0)' } },
          axisLabel: { color: '#9da5b2', fontSize: '11' }
        },
        visualMap: [
          {
            min: minItem,
            max: maxItem,
            show: false,
            type: 'piecewise',
            calculable: true,
            pieces: this.generatePieces(maxItem, colorBox, minItem)
          }
        ],
        yAxis: {
          type: 'category',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#c1c5ca', type: 'dashed' } },
          axisLabel: { color: '#9da5b2', fontSize: '11' },
          data: this.data.buckets
        },
        series: [
          {
            type: 'heatmap',
            data: this.data.nodes || [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
    }
  }
};
</script>
